import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { LotSizing } from '@/types/core/lot-sizing/lot-sizing';
import { useCreatePurchaseOrderAction } from './hooks/use-create-purchase-order-action';

type LotSizingCreatePurchaseOrderProps = {
  lotSizing: LotSizing;
};

export function LotSizingCreatePurchaseOrder({
  lotSizing,
}: LotSizingCreatePurchaseOrderProps) {
  const { t } = useTranslation('lotSizing');
  const { handleSubmit, onSubmit, isPending, canCreate, validationErrorKey } =
    useCreatePurchaseOrderAction(lotSizing);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            {lotSizing.purchaseOrders.length === 0 && (
              <Button disabled={!canCreate || isPending} type='submit'>
                {t('createPO')}
              </Button>
            )}
          </span>
        </TooltipTrigger>
        {!canCreate && validationErrorKey && (
          <TooltipContent>{t(validationErrorKey)}</TooltipContent>
        )}
      </Tooltip>
    </form>
  );
}
